module.exports = __webpack_public_path__ + "media/images/pc/stores/common/instagram/photographer_sns_01-d17e7284fc4d2cf68208508ec3200940.jpg";